import { NoticeBlock, type NoticeBlockProps } from "@/components/NoticeBlock.tsx";
import type { Translatable } from "@/modules/l10n/getTransText.ts";
import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

export interface GeneralBaValidationBlockProps {
    title?: Translatable;
    description?: Translatable;
    button?: ReactNode;
    color?: NoticeBlockProps["color"];
}

export function GeneralBaValidationBlock({ title, description, ...noticeProps }: GeneralBaValidationBlockProps) {
    return (
        <NoticeBlock icon="jp-warning-icon" {...noticeProps}>
            <b className="uppercase">{title ? title : <Trans>Account details must be validated</Trans>}</b>
            <br />
            {description && <>{description} </>}
            <br />
            <Trans>
                You will be able to set up payment methods and use cloud services once the validation is approved.
            </Trans>
        </NoticeBlock>
    );
}
